import { STORAGE, storageGet, storageSet, storageRemove } from '../utils/storageKeys.js';

/**
 * Thin fetch wrapper for the Orbeat API (same-origin `/api`, proxied by
 * Vite in dev). Holds the Bearer token; every failure resolves to
 * `{ ok: false }` so the game never breaks when offline.
 */
export default class ApiClient {
  constructor(base = '/api') {
    this.base = base;
    this.token = storageGet(STORAGE.AUTH_TOKEN) || null;
  }

  setToken(token) {
    this.token = token || null;
    if (token) storageSet(STORAGE.AUTH_TOKEN, token);
    else storageRemove(STORAGE.AUTH_TOKEN);
  }

  async request(endpoint, { method = 'GET', body = null, timeoutMs = 10000 } = {}) {
    const headers = { 'Content-Type': 'application/json' };
    if (this.token) headers.Authorization = `Bearer ${this.token}`;

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const res = await fetch(this.base + endpoint, {
        method,
        headers,
        body: body ? JSON.stringify(body) : null,
        signal: controller.signal
      });
      let data = null;
      try {
        data = await res.json();
      } catch {
        /* non-JSON response */
      }
      return { ok: res.ok, status: res.status, data };
    } catch {
      return { ok: false, status: 0, data: null }; // offline / timeout
    } finally {
      clearTimeout(timer);
    }
  }

  get(endpoint) {
    return this.request(endpoint);
  }

  post(endpoint, body) {
    return this.request(endpoint, { method: 'POST', body });
  }
}
